
import { cn } from "@/lib/utils";

interface EventStatusBadgeProps {
  status: string;
}

export const EventStatusBadge = ({ status }: EventStatusBadgeProps) => {
  return null; // Completely remove the status badge
};
